export const sortTypes = Object.freeze({
  TIME: 'time',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  DELETED_AT: 'deletedAt',
  TITLE: 'title',
});
